import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../../assets/images/construction-image.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "header-title md:!tw-text-[20px]" }, "Welcome to iknowa,", -1)
const _hoisted_2 = { class: "header-sub-title" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "welcome__image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "welcome__text" }, [
  /*#__PURE__*/_createElementVNode("p", null, " Check out your new HQ. Access Verified, Training, Jobs, Subcontractors and greater protections, with ease. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!
  const _component_TradePersonBenefitsModal = _resolveComponent("TradePersonBenefitsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.isShowWelcomeModal)
      ? (_openBlock(), _createBlock(_component_CommonDialog, {
          key: 0,
          isShowHeader: false,
          isShowBackButton: false,
          width: "560px",
          "max-width": "100%",
          height: "auto",
          className: ['welcome__modal_box']
        }, {
          body: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", _hoisted_2, _toDisplayString($setup.userName), 1),
            _hoisted_3,
            _hoisted_4
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: $setup.onClickExploreButton,
              class: "button button-orange"
            }, {
              default: _withCtx(() => [
                _createTextVNode("ExplorE 🚀")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.isShowTradePersonBenefitsModal)
      ? (_openBlock(), _createBlock(_component_TradePersonBenefitsModal, {
          key: 1,
          onOnClickClosePreviewModalButton: $setup.onClickClosePreviewModalButton
        }, null, 8, ["onOnClickClosePreviewModalButton"]))
      : _createCommentVNode("", true)
  ], 64))
}